import React, { useState } from 'react';
import { Link as RouterLink } from 'next/link';
import { useMutation } from '@apollo/react-hooks';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Grid, Typography, Box, Link, Hidden } from '@material-ui/core';
import { Button, TextInput } from '@eureca/eureca-ui';

import { REQUEST_RESET_PASSWORD } from '@/api/mutation/consultant/index';
import { yupValidators } from '@/helpers/validations';

const yupValidation = Yup.object().shape({
  email: yupValidators.email,
});

function ResetPassword({ submitSuccess }) {
  const [errorStatus, setErrorStatus] = useState('');
  const [requestReset, { loading }] = useMutation(REQUEST_RESET_PASSWORD, {
    onError() {
      setErrorStatus('Esse e-mail não foi encontrado. Tente outro.');
    },
    onCompleted() {
      submitSuccess();
    },
  });

  function handleSubmit(values) {
    requestReset({ variables: { email: values.email } });
  }

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    onSubmit: handleSubmit,
    validationSchema: yupValidation,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={3} alignItems="center" justify="center">
        <Hidden only="xs">
          <Grid item sm={8} md={6}>
            <img
              src="/intro-somos-humanos.svg"
              alt="Somos todos humanos - Eureca"
            />
          </Grid>
        </Hidden>
        <Hidden smDown>
          <Grid item md={1} />
        </Hidden>
        <Grid item container xs={12} sm={8} md={4} spacing={0}>
          <Grid item xs={12}>
            <Box mb={3.75} textAlign={{ xs: 'center', md: 'left' }}>
              <Typography variant="h3">
                Esqueceu sua senha? Não tem problema...
              </Typography>
            </Box>
            <TextInput
              variant="outlined"
              label="E-mail"
              name="email"
              onChange={(e) => {
                formik.handleChange(e);
                setErrorStatus('');
              }}
              onBlur={(e) => {
                formik.handleBlur(e);
                setErrorStatus('');
              }}
              value={formik.values.email}
              error={Boolean(
                (formik.touched.email && formik.errors.email) || errorStatus,
              )}
              helperText={
                formik.touched.email && formik.errors.email
                  ? formik.errors.email
                  : errorStatus
              }
            />
            <Box mt={4} mb={3}>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  fullWidth
                  disabled={!formik.isValid || loading}
                  onClick={formik.handleSubmit}
                >
                  Redefinir a senha
                </Button>
              </Grid>
            </Box>
            <Box textAlign="center">
              <Grid item xs={12}>
                <Typography>
                  Não lembra o email?{' '}
                  <Link component={RouterLink} href="/ajuda">
                    Encontrar ajuda
                  </Link>
                </Typography>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}

export default ResetPassword;
